import { makeObservable, observable, action, computed, flow } from "mobx";
import { renameDrive as renameDriveService } from "../../../../../services/drives";

class RenameModalStore {
  isOpen = false;
  type = 'document'; // 'drive' | 'folder' | 'document'
  currentName = '';
  defaultValue = '';
  isSubmitting = false;
  resourceId = null;
  onConfirmCallback = null;

  constructor() {
    makeObservable(this, {
      
      isOpen: observable,
      type: observable,
      currentName: observable,
      defaultValue: observable,
      isSubmitting: observable,
      resourceId: observable,

      open: action,
      close: action,
      setCurrentName: action,
      setIsSubmitting: action,
      reset: action,

      confirm: flow,

      hasChanges: computed,
      isValid: computed,
    });
  }

  open = ({ type, defaultValue, resourceId, onConfirm }) => {
    this.type = type || 'document';
    this.defaultValue = defaultValue || '';
    this.currentName = defaultValue || '';
    this.resourceId = resourceId;
    this.onConfirmCallback = onConfirm;
    this.isOpen = true;
  };

  close = () => {
    this.isOpen = false;
    this.reset();
  };

  setCurrentName = (name) => {
    this.currentName = name;
  };

  setIsSubmitting = (status) => {
    this.isSubmitting = status;
  };

  *confirm() {
    if (!this.isValid || this.isSubmitting) return;

    this.setIsSubmitting(true);
    const trimmedName = this.currentName.trim();

    try {
      if (this.type === 'drive' && this.resourceId) {
        const response = yield renameDriveService({
          vault_uuid: this.resourceId,
          name: trimmedName
        });
        
        if (this.onConfirmCallback) {
          yield this.onConfirmCallback({
            name: trimmedName,
            resourceId: this.resourceId,
            type: this.type,
          });
        }
      } else if (this.onConfirmCallback) {
        yield this.onConfirmCallback({
          name: trimmedName,
          resourceId: this.resourceId,
          type: this.type,
        });
      }

      this.close();
    } catch (error) {
      console.error('Error during rename confirmation:', error);
      throw error;
    } finally {
      this.setIsSubmitting(false);
    }
  }

  reset = () => {
    this.type = 'document';
    this.currentName = '';
    this.defaultValue = '';
    this.resourceId = null;
    this.onConfirmCallback = null;
    this.isSubmitting = false;
  };

  get hasChanges() {
    return this.currentName.trim() !== this.defaultValue.trim();
  }

  get isValid() {
    return this.currentName.trim().length > 0;
  }
}

export default RenameModalStore;

